import {
  Card,
  Collapse,
  Icons,
  Statistic,
  TextField,
} from '@pankod/refine-antd'
import React from 'react'

import {
  PROGRAM_LOCAL_STATE,
  PROGRAM_LOCAL_STATE_LABEL,
} from '@resources/lms-management/program-lokal/types'
import { TLMSProgramDetail } from '@resources/lms-management/program/types'

const ProgramLocalStatusStats = (props: {
  programData?: TLMSProgramDetail
}) => {
  const programData = props.programData
  const STATS = [
    {
      icon: <Icons.ClockCircleOutlined className="mr-2" />,
      state: PROGRAM_LOCAL_STATE.DRAFT,
    },
    {
      icon: <Icons.PlayCircleOutlined className="mr-2" />,
      state: PROGRAM_LOCAL_STATE.PUBLISHED,
    },
    {
      icon: <Icons.CheckCircleOutlined className="mr-2" />,
      state: PROGRAM_LOCAL_STATE.DONE,
    },
  ]

  return (
    <Collapse>
      <Collapse.Panel
        header={<TextField value="Statistik Status Program Lokal" strong />}
        key="stats"
      >
        <div className="flex gap-4 w-full justify-between">
          {STATS.map(({ icon, state }) => (
            <Card key={state} type="inner" className="w-full" size="small">
              <Statistic
                prefix={icon}
                title={PROGRAM_LOCAL_STATE_LABEL[state]}
                value={
                  programData?.statusProgramLocal?.find(
                    ({ status }) => status === state,
                  )?.count
                }
              />
            </Card>
          ))}
        </div>
      </Collapse.Panel>
    </Collapse>
  )
}

export default ProgramLocalStatusStats
